<template>
  <b-row v-if="parentPath && path" style="height:100%;padding-bottom:55px">
    <b-col md="12">
      <b-card
        v-tooltip="uniToolTipTranslation('S654', 'en-US')"
        :header="uniTranslation('S654')"
        class="bottom-card card-panel"
        style="height:100%;"
        :style="{ backgroundColor: coloreSfondo }"
      >
        <GeometryPicker :path="path"></GeometryPicker>
        <el-collapse accordion>
          <el-collapse-item
            v-tooltip="uniToolTipTranslation('S574', 'en-US')"
            name="tubesAccordion"
            class="no-border-bottom"
          >
            <template slot="title">{{ uniTranslation("S574") }}</template>
            <MaterialPicker
              :parent-path="path"
              :name="'.tube.material.id'"
              :tags="'.tube.material.tags'"
            ></MaterialPicker>
            <UnidataEditor :parent-path="path" :name="'.tube.tickness'"></UnidataEditor>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item
            v-tooltip="uniToolTipTranslation('S576', 'en-US')"
            name="finAccordion"
            class="no-border-bottom"
          >
            <template slot="title">{{ uniTranslation("S576") }}</template>
            <MaterialPicker
              :parent-path="path"
              :name="'.fin.material.id'"
              :tags="'.fin.material.tags'"
            ></MaterialPicker>
            <UnidataEditor :parent-path="path" :name="'.fin.pitch'"></UnidataEditor>
            <UnidataEditor :parent-path="path" :name="'.fin.tickness'"></UnidataEditor>
            <UnidataEditor :parent-path="path" :name="'.fin.height'"></UnidataEditor>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item
            v-tooltip="uniToolTipTranslation('S452', 'en-US')"
            name="mainfoldsAccordion"
            class="no-border-bottom"
          >
            <template slot="title">{{ uniTranslation("S452") }}</template>
            <ManifoldPanel :path="path"></ManifoldPanel>
          </el-collapse-item>
        </el-collapse>
        <el-collapse accordion>
          <el-collapse-item
            v-tooltip="uniToolTipTranslation('S1636', 'en-US')"
            name="airSideAdvancedAccordion"
          >
            <template slot="title">{{ uniTranslation("S1636") }}</template>
            <UnidataEditorCorrelator
              :parent-path="path"
              group="AtmosphericGroup"
            ></UnidataEditorCorrelator>
            <UnidataEditorCorrelator
              :parent-path="path"
              :selected-option-index.sync="airDensityGroupIndex"
              group="AirDensityGroup"
            ></UnidataEditorCorrelator>
            <UnidataEditor
              v-if="bSpessoreGhiaccio"
              :parent-path="path"
              :name="'.frostTickness'"
            ></UnidataEditor>
          </el-collapse-item>
        </el-collapse>

        <div>
          <div class="row">
            <b-button variant="primary" @click="viewDetailsPdcFluid">{{
              uniTranslation("S2040")
            }}</b-button>
          </div>

          <b-modal v-model="modalShow" :title="uniTranslation('S2040')">
            <!--b-table
            class="table table-striped table-sm"
            striped
            hover
            :items="listaTask"
            :fields="fieldsTask"
            @row-clicked="myRowClickTask"
            ></b-table-->
            <b-row v-if="bPerditediCaricoFluidoGradi">
              <b-col>
                <b-card
                  class="bottom-card card-panel"
                  style="height:100%;"
                  :title="uniTranslation('S1702')"
                >
                  <b-card-text>
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.perditediCaricoFluidoGradi'"
                    ></UnidataEditor>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  class="bottom-card card-panel"
                  style="height:100%;"
                  :title="uniTranslation('S2030')"
                >
                  <b-card-text>
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.perditediCaricoFluido'"
                    ></UnidataEditor>
                  </b-card-text>
                  <b-card-text v-if="bPerditediCaricoCollettoreIngresso">
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.perditediCaricoCollettoreIngresso'"
                    ></UnidataEditor>
                  </b-card-text>
                  <b-card-text v-if="bPerditediCaricoCollettoreUscita">
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.perditediCaricoCollettoreUscita'"
                    ></UnidataEditor>
                  </b-card-text>
                  <b-card-text>
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.perditediCaricoFluidoTotali'"
                    ></UnidataEditor>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card
                  class="bottom-card card-panel"
                  style="height:100%;"
                  :title="uniTranslation('S2032')"
                >
                  <b-card-text>
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.velocitaFluidoFaseLiquida'"
                    ></UnidataEditor>
                  </b-card-text>
                  <b-card-text v-if="bPerditediCaricoCollettoreIngresso">
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.velocitaCollettoreIngresso'"
                    ></UnidataEditor>
                  </b-card-text>
                  <b-card-text v-if="bPerditediCaricoCollettoreUscita">
                    <UnidataEditor
                      :parent-path="path"
                      :name="'.velocitaCollettoreUscita'"
                    ></UnidataEditor>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-modal>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import GeometryPicker from "../shared/GeometryPicker";
import MaterialPicker from "../shared/MaterialPicker";
import ManifoldPanel from "../shared/ManifoldPanel";
import UnidataEditor from "../unidata/UnidataEditor";
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
// import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
import { /*Radio, Select, Option,*/ Collapse, CollapseItem } from "element-ui";
import jsonHelper from "../../shared/jsonHelper";
// import materialService from "../../services/backend/materialService";

export default {
  components: {
    GeometryPicker,
    MaterialPicker,
    ManifoldPanel,
    UnidataEditor,
    UnidataEditorCorrelator /*,
    UnidataEditorCorrelatorOptionList,
    "el-radio": Radio,
    "el-select": Select,
    "el-option": Option*/,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /*tubeMaterialList: [],
      selectedTubeMaterial: '',
      finMaterialList: [],
      selectedFinMaterial: '',*/
      path: null,
      airDensityGroupIndex: 0,
      modalShow: false,
      bPerditediCaricoCollettoreIngresso: false,
      bPerditediCaricoCollettoreUscita: false,
      bPerditediCaricoFluidoGradi: false,
      bSpessoreGhiaccio: false,
      coloreSfondo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },

    /*'selectedTubeMaterial':function (nv, ov){
      if(nv != null && nv != undefined){
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".tube.material.id",
          value: idg
        });
      }
    },
    'selectedFinMaterial':function (nv, ov){
      if(nv != null && nv != undefined){
        var idg = parseInt(nv);
        this.$store.dispatch("changeProjectProperty", {
          path: this.path + ".fin.material.id",
          value: idg
        });
      }
    }    */
    airDensityGroupIndex: function(newval /*, oldval*/) {
      //this.$store.dispatch('changeFluidCalculationModeProperty',newval);
      //alert("store airDensityGroupIndex")

      this.$store.dispatch("changeProjectProperty", {
        path: this.path + ".airDensityGroupIndex",
        value: newval
      });
    }
  },
  mounted: function() {
    var that = this;

    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;

    var modality = jsonHelper.getProperty(that.projects, that.parentPath + ".modality");

    that.bPerditediCaricoFluidoGradi = false;

    if (modality == 1) {
      that.bPerditediCaricoFluidoGradi = false;
      that.bSpessoreGhiaccio = false;
    } // riscaldamento

    if (modality == 2) {
      that.bPerditediCaricoFluidoGradi = false;
      that.bSpessoreGhiaccio = true;
    } // raffreddamento

    if (modality == 5) {
      that.bPerditediCaricoFluidoGradi = false;
      that.bSpessoreGhiaccio = false;
    } // vapore

    if (modality == 3) {
      that.bPerditediCaricoFluidoGradi = true;
      that.bSpessoreGhiaccio = false;
    } // condensazione

    if (modality == 4) {
      that.bPerditediCaricoFluidoGradi = true;
      that.bSpessoreGhiaccio = true;
    } // espansione diretta

    if (modality == 6) {
      that.bPerditediCaricoFluidoGradi = true;
      that.bSpessoreGhiaccio = true;
    } // evaporatore a pompa
    if (modality == 7) {
      that.bPerditediCaricoFluidoGradi = true;
      that.bSpessoreGhiaccio = false;
    } // condensazione parziale

    this.$store.subscribe(function(mutation) {
      /* , state */
      if (mutation.type === "changeProjectProperty") {
        if (mutation.payload.path.startsWith(that.path + ".manifold.calculationType")) {
          if (mutation.payload.value > 0) {
            if (modality == 4) {
              that.bPerditediCaricoCollettoreIngresso = false;
              that.bPerditediCaricoCollettoreUscita = true;
            } else {
              that.bPerditediCaricoCollettoreIngresso = true;
              that.bPerditediCaricoCollettoreUscita = true;
            }
          } else {
            that.bPerditediCaricoCollettoreIngresso = false;
            that.bPerditediCaricoCollettoreUscita = false;
          }
        }
      }
    });

    /*var that = this;  
    materialService.getMaterial().then(function(data) {
      data.forEach(element => {
        that.tubeMaterialList.push({
          'description': element.description,
          'materialID': element.materialID,
          'thermalConductivity': element.thermalConductivity,
          'density': element.density,
          'price': element.price
        });
      });
      that.selectedTubeMaterial = jsonHelper.getProperty(that.projects,that.path + ".tube.material.id");
    });

    materialService.getMaterial().then(function(data) {
      data.forEach(element => {
        that.finMaterialList.push({
          'description': element.description,
          'materialID': element.materialID,
          'thermalConductivity': element.thermalConductivity,
          'density': element.density,
          'price': element.price
        });
      });
      that.selectedFinMaterial = jsonHelper.getProperty(that.projects,that.path + ".fin.material.id");
    });*/

    that.coloreSfondo = that.cardColors[0] + " !important";
  },
  methods: {
    viewDetailsPdcFluid() {
      this.modalShow = true;
    }
  }
};
</script>

<style lang="scss">
.materialSelectLabel {
  margin-top: 5px;
  //padding-left: 5px;
}
.materialSelect {
  width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  padding: 0 5px;
  .el-input {
    .el-input__inner {
      height: 30px;
    }
  }
}

div {
  hr {
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata {
    display: flex;
    flex-direction: row;
    .radio-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width: 160px;
      label {
        margin-bottom: 0px;
      }
      .el-radio + .el-radio {
        margin-left: 0px;
      }
    }
  }
}
</style>
